/** CoStar.Api.LoopNet.MobileServices.ViewModels.Registration.DefaultCostarUserMatchType */
export var DefaultCostarUserMatchType;
(function (DefaultCostarUserMatchType) {
    DefaultCostarUserMatchType[DefaultCostarUserMatchType["None"] = 0] = "None";
    DefaultCostarUserMatchType[DefaultCostarUserMatchType["CoStarUser"] = 1] = "CoStarUser";
    DefaultCostarUserMatchType[DefaultCostarUserMatchType["CoStarContact"] = 2] = "CoStarContact";
    DefaultCostarUserMatchType[DefaultCostarUserMatchType["CoStarUserNotFullMatch"] = 3] = "CoStarUserNotFullMatch";
    DefaultCostarUserMatchType[DefaultCostarUserMatchType["BasicLoopnetUser"] = 4] = "BasicLoopnetUser";
    DefaultCostarUserMatchType[DefaultCostarUserMatchType["BasicLoopnetUserWithCoStarContact"] = 5] = "BasicLoopnetUserWithCoStarContact";
})(DefaultCostarUserMatchType || (DefaultCostarUserMatchType = {}));
